module.exports = __webpack_public_path__ + "img/nvq.b8fb6ee2.png";